import {
  useRemoveIncidentReportLogo,
  useUploadIncidentReportLogo,
} from '@hakimo-ui/hakimo/data-access';
import { DataVersion, IncidentProduct } from '@hakimo-ui/hakimo/types';
import { toast } from '@hakimo-ui/hakimo/util';

interface Args {
  product: IncidentProduct;
  alarmId: number | string;
  onDone: () => void;
  dataVersion?: DataVersion;
}

export function useReportLogoActions({
  product,
  alarmId,
  onDone,
  dataVersion,
}: Args) {
  const onError = (err: Error) => toast(err.message, { type: 'error' });

  const { mutate: uploadLogo, isLoading: isUploading } =
    useUploadIncidentReportLogo(
      product,
      alarmId,
      () => {
        toast('Report logo updated');
        onDone();
      },
      onError,
      dataVersion
    );

  const { mutate: removeLogo, isLoading: isRemoving } =
    useRemoveIncidentReportLogo(
      product,
      alarmId,
      () => {
        toast('Report logo removed');
        onDone();
      },
      onError,
      dataVersion
    );

  return { uploadLogo, removeLogo, isUploading, isRemoving };
}

export default useReportLogoActions;
